import { IconName } from '@talos/kyoko';
import type { TabGroupSpec } from '../../../../types/LayoutConfig';

export const PANEL_COMPONENT_GROUPS = [
  { type: 'main', label: 'Main content', icon: IconName.ArrowsExpand },
  { type: 'symbol', label: 'Single symbol', icon: IconName.OrderBook },
  { type: 'blotters', label: 'Blotters', icon: IconName.Table },
  { type: 'symbol-setup', label: 'Symbol Setup', icon: IconName.OrderBook },
  { type: 'pricing', label: 'Pricing', icon: IconName.Collection },
  { type: 'execution', label: 'Execution', icon: IconName.Dealer },
  { type: 'buying-power', label: 'Buying Power', icon: IconName.Table },
  { type: 'net-acquisition', label: 'Net Acquisition', icon: IconName.Collection },
  { type: 'admin', label: 'Admin', icon: IconName.PencilField },
  { type: 'forms', label: 'Forms', icon: IconName.PencilField },
  { type: 'monitoring', label: 'Monitoring', icon: IconName.DeviceDesktop },
  { type: 'signals', label: 'Intel', icon: IconName.ChartLine },
].reduce((res: Record<string, TabGroupSpec>, group: TabGroupSpec) => {
  res[group.type] = group;
  return res;
}, {});
